export const apiBaseURL = (version: string = "v2") =>
  `${process.env.NEXT_PUBLIC_MIRROR_API_BASE_URL}/api/${version}`;
